"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Job;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Job = class Job {
    static async insert(context, jobObj, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(jobObj, [
            'id',
            'job',
            'status',
            'result',
            'fk_user_id'
        ]);
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.JOBS, insertObj);
        return this.get(context, id, ncMeta);
    }
    static async update(context, jobId, jobObj, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(jobObj, [
            'status',
            'result'
        ]);
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.JOBS, (0, _modelUtils.prepareForDb)(updateObj, 'result'), jobId);
        await _NocoCache.default.update('root', `${_globals.CacheScope.JOBS}:${jobId}`, (0, _modelUtils.prepareForResponse)(updateObj, 'result'));
        return res;
    }
    static async delete(context, jobId, ncMeta = _Noco.default.ncMeta) {
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.JOBS, jobId);
        await _NocoCache.default.deepDel('root', `${_globals.CacheScope.JOBS}:${jobId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
    }
    static async get(context, id, ncMeta = _Noco.default.ncMeta) {
        let jobData = id && await _NocoCache.default.get('root', `${_globals.CacheScope.JOBS}:${id}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!jobData) {
            jobData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.JOBS, id);
            jobData = (0, _modelUtils.prepareForResponse)(jobData, 'result');
            await _NocoCache.default.set('root', `${_globals.CacheScope.JOBS}:${id}`, jobData);
        }
        return jobData && new Job(jobData);
    }
    static async list(context, opts, ncMeta = _Noco.default.ncMeta) {
        const jobList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.JOBS, opts);
        return jobList.map((job)=>{
            return new Job((0, _modelUtils.prepareForResponse)(job, 'result'));
        });
    }
    constructor(data){
        Object.assign(this, data);
    }
};
